import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteKundenArtCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteKundenArtCommandService],
  exports: []
})
export class DeleteKundenArtCommandServiceModule { }
